export default __webpack_public_path__ + "static/media/GH_bathroom.e673ddc1.jpg";